<template>
  <div id="videos">
    <v-container class="pa-0">
        <v-layout>
            <v-flex class="xs12 sm12 mb-5">
                <v-btn fab absolute left :to="{ path: '/admin/families'}" class="ml-3 pf-btn-fab">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
    <v-container grid-list-md fluid>
        <v-layout wrap>
          <v-flex xs12 sm6 md6 lg4 xl3 pa-2 v-for="project of Project" :key="project.id">
            <router-link :to="{ path: `/admin/projects/${project.id}`, query: { humanId: accountData.human, ppn: accountData.ppn, access: accountData.access, accountId: accountData.id }}">
            <v-card
              class="theme--light rounded-corner" height="100%"
            >
            <v-responsive class="text-xs-center pa-5">
              <img src="static/videoIcon.png">
            </v-responsive>
            <v-card-text class="title text-xs-center">{{ project.title }}</v-card-text>
            </v-card>
            </router-link>
          </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid v-if="!Project.length" class="text-center">
        <img src="static/NoVideos.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No Project(s) Found !! </b></h4>
    </v-container>
  </div>
</template>
<script>
import { getCollection } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
/* global session config store */
export default {
  data: () => ({
    accountData: {},
    config: config,
    pagination: {
      sortBy: 'createdAt', // The field that you're sorting by
      descending: false,
      rowsPerPage: config.dom.rowsPerPage
    },
  }),
  computed: {
    ...mapGetters(['']),
    Project: {
      get () {
        return store.state.Project;
      },
      set (value) {
        store.commit('setProject', value);
      }
    }
  },
  watch: {
    Project (newValue) {
      if (newValue) {
        this.projectObj = newValue.find((project) => project.id === this.projectId && project.account === this.accountData.id);
        if (this.projectObj && this.projectObj.section) {
          this.sectionList = this.projectObj.section.filter(section => section.section && section.section.items.length > 0);
          this.sectionList = this.sectionList.map(section => section.section);
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    try {
      this.accountData = JSON.parse(JSON.stringify(this.$route.params.item));
      await this.projectInitialize();
    } catch (e) {
      this.$router.push({ path: '/admin/families' });
    }
  },
  methods: {
    async projectInitialize () {
      let populate = [{ path: 'section.section', populate: 'items.item' }];
      let where = { account: this.accountData.id };
      let { error, data } = await getCollection('Project', true, 0, populate, where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Project = data;
        }
      }
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/VideoProject/projectList.vue